// pothos manager «Команда» — /api/getManagerTeamOverview. Отделы и их
// факты читаются из dept_*-колонок каталога pothos_assets («кто последний»
// по отделу), Upwork — из dept_upwork. Статус-корзины: in_work =
// uploaded+in_work, review = qa, shipped = shipped+client_accepted;
// rejected и client_rejected раздельно. week_new — загрузки за 7 дней.
import { z } from 'zod';

export const PothosTeamStatsSchema = z.object({
  total: z.number(),
  in_work: z.number(),
  review: z.number(),
  accepted: z.number(),
  shipped: z.number(),
  rejected: z.number(),
  client_rejected: z.number(),
  week_new: z.number(),
});
export type PothosTeamStats = z.infer<typeof PothosTeamStatsSchema>;

export const PothosTeamPersonSchema = PothosTeamStatsSchema.extend({
  name: z.string(),
});
export type PothosTeamPerson = z.infer<typeof PothosTeamPersonSchema>;

export const PothosTeamPlanSchema = z.object({
  plan: z.number(),
  done: z.number(),
  remaining: z.number(),
});
export type PothosTeamPlan = z.infer<typeof PothosTeamPlanSchema>;

export const PothosTeamDeptSchema = z.object({
  key: z.enum(['designer', 'it', 'research', 'scrapper', 'photographer', 'qa', 'mgmt']),
  fact: PothosTeamStatsSchema,
  people: z.array(PothosTeamPersonSchema),
  plan: PothosTeamPlanSchema.nullable(),
});
export type PothosTeamDept = z.infer<typeof PothosTeamDeptSchema>;

export const PothosManagerTeamOverviewResSchema = z.object({
  departments: z.array(PothosTeamDeptSchema),
  upwork: z.array(PothosTeamPersonSchema),
});
export type PothosManagerTeamOverviewRes = z.infer<typeof PothosManagerTeamOverviewResSchema>;
